import { boldFont, getRelativeFontSize, mediumFont } from "../../utils/styles";

const IdealTimeStyles = {
  contantWrapper: {
    display: "flex",
    wisth: "100%",
    flexDirection: "column",
    padding: "0 12px 12px 12px",
  },

  heading: {
    ...boldFont,
    fontSize: getRelativeFontSize(10),
    marginTop: "-20px",
    marginBottom: "20px",
    textAlign: "center",
  },

  text: {
    ...mediumFont,
    "& span": {
      ...boldFont,
    },
  },

  timer : {
    height : "70px",
    display : "flex",
    alignItems: "center",
    gap : "20px",
    '& img' : {
      height : "25px",
      width: "25px",
      marginRight:  "10px"
    }
  },

  buttonWrapper: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    marginTop: "20px",
    "& button": {
      width: "150px",
    },
  },
};

export default IdealTimeStyles;
